import { render, staticRenderFns } from "./MppAppSubject.vue?vue&type=template&id=3a138cd7&scoped=true"
import script from "./MppAppSubject.vue?vue&type=script&lang=js"
export * from "./MppAppSubject.vue?vue&type=script&lang=js"
import style0 from "./MppAppSubject.vue?vue&type=style&index=0&id=3a138cd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a138cd7",
  null
  
)

export default component.exports